export const COLOR_MEDIUM_GRAY = '#E5E5E5';

export const COLOR_CV_1 = '#D0F8DC';
export const COLOR_CV_2 = '#93D1A4';
export const COLOR_CV_3 = '#6AA67A';
export const COLOR_CV_4 = '#528560';
export const COLOR_CV_5 = '#40774F';
export const COLOR_CV_6 = '#275D36';
export const COLOR_CV_7 = '#235431';
export const COLOR_CV_8 = '#1F4A2B';
export const COLOR_CV_9 = '#1B4126';
export const COLOR_CV_10 = '#173820';

export const COLOR_WHITE = '#FFFFFF';
export const COLOR_RED = '#F5222D';
export const COLOR_YELLOW = '#FADB14';
export const COLOR_GREEN = '#52C41A';

export const COLOR_NEUTRAL_1 = '#FFFFFF';
export const COLOR_NEUTRAL_2 = '#FAFAFA';
export const COLOR_NEUTRAL_3 = '#F5F5F5';
export const COLOR_NEUTRAL_4 = '#F0F0F0';
export const COLOR_NEUTRAL_5 = '#D9D9D9';
export const COLOR_NEUTRAL_6 = '#BFBFBF';
export const COLOR_NEUTRAL_7 = '#8C8C8C';
export const COLOR_NEUTRAL_8 = '#595959';
export const COLOR_NEUTRAL_9 = '#434343';
export const COLOR_NEUTRAL_10 = '#262626';
export const COLOR_NEUTRAL_11 = '#1F1F1F';
export const COLOR_NEUTRAL_12 = '#141414';
export const COLOR_NEUTRAL_13 = '#000000';

export const COLOR_LINK = '#3C9AE8';
